module.exports = __webpack_public_path__ + "static/media/boat1@ax.69abdf6e.jpg";